module.exports = __webpack_public_path__ + "img/support-general.ccfca64b.svg";